import React, { FC, PropsWithChildren } from 'react'

import { css } from '@linaria/core'
import { styled } from '@linaria/react'

import { BadgeCounter } from 'components/designSystem/Badge/BadgeCounter'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const EdnaCounterMessage: FC<
  PropsWithChildren & { isDesktop?: boolean }
> = ({ children, isDesktop = false }) => {
  const { unreadMessageSupportEdna } = useShallowEqualSelector(
    ({ userReducer: { unreadMessageSupportEdna } }) => ({
      unreadMessageSupportEdna,
    })
  )

  if (unreadMessageSupportEdna > 0) {
    return (
      <>
        {unreadMessageSupportEdna > 0 && (
          <Badge
            counter={unreadMessageSupportEdna}
            data-name="messages-counter"
            className={isDesktop ? badgeDesktopCss : ''}
          />
        )}
        {children}
      </>
    )
  }

  return children
}

const Badge = styled(BadgeCounter)`
  position: absolute;
  right: 50%;
  transform: translateX(100%);
  top: 5px;
`

const badgeDesktopCss = css`
  right: 5px;
  top: 0;
  transform: none;
`
